import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encryptToken } from "../../../Services/Encryption/EncryptionToken";
import PopupAHSF from "../../../Components/PopupAHSF";
import TableAHSF from "../../../Components/TableAHSF";
import ButtonAHSF from "../../../Components/ButtonAHSF";
import { CloseTasksCcompleteInitialAssessment } from "../../../Redux/Reducers/Manager/SubTask";
import { setRefreshTable } from "../../../Redux/Reducers/Shared/VariousVariables";
import Swal from "sweetalert2";
import { SetArrayDataCheckBoks } from "../../../Redux/Reducers/Shared/CheckBox";

const RequestsEvaluation = () => {
  const dispatch = useDispatch();
  const SubTaskReducerResult=useSelector((state)=>state.SubTaskReducer.CloseTasksCcompleteInitialAssessmentResult)
  const arrayDataCheckBoks = useSelector(
    (state) => state.arrayDataCheckBoks.arrayDataCheckBoks["SubtasksList_"]
  );
  const [popUpBodyStatus, setPopUpBodyStatus] = useState(false);
  const state = useSelector((state) => {
    return {
      UserInfo: state.UserInfo.UserInfo.userToken,
      //   RoleByUserGuid: state.RoleByUserGuid.RoleByUserGuid,
      //   ApplicationInformation:
      //     state.ApplicationInformation.ApplicationInformation,
    };
  });
  const jsonData = useSelector((state) => state.FetchDataJson.JsonData);
  //   console.log(arrayDataCheckBoks.map((ele)=>ele?.subTaskId), "dddddsdsdddddddddddddd");

  const navigate = useNavigate();
  const culomEdite = ["email", "fullName"];
  const staticKeyEdite = ["userGUID", "ssoguid", "lastUpdate"];

  const RequestAccessor = [
    {
      KeyName: "applicationNumber",
      ShowStatus: true,
      NmaeColumn: "رقم الطلب",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicationNumber",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "fieldName",
      ShowStatus: true,
      NmaeColumn: "الحقل",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researcherName",
      ShowStatus: true,
      NmaeColumn: "اسم المتقدم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "foundationName",
      ShowStatus: true,
      NmaeColumn: "اسم المؤسسة",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "applicantsName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "researchProjectTitleInArabic",
      ShowStatus: true,
      NmaeColumn: "اسم المشروع",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "projectName",
        keyValueName: "aI_ApplicationInformationId",
      },
      DropdownFiltrationStatus: false,
      GroupOfColumns: false,
    },
    {
      KeyName: "statusName",
      ShowStatus: true,
      NmaeColumn: "حالة التقييم",
      TotalNumber: true,
      DropdownFiltration: {
        keyTextName: "statusNameAr",
        keyValueName: "appStatusId",
      },
      DropdownFiltrationStatus: true,
      GroupOfColumns: false,
    },
  ];
  const RequestsManagerBtns = [
    {
      Click: async (e) => {
        navigate("/SRFund/manager/EvaluationInformation/" + e.target.value);
      },
      content: "",
      className: "bi bi-pencil-square",
      id: "editBtn",
      title: "عرض",
      ShowStatus: true,
    },
    // {
    //   Click: async (e) => {
    //     navigate("/SRFund/manager/EvaluationInformation/" + e.target.value);
    //   },
    //   content: "",
    //   className: "bi bi-pencil-square",
    //   id: "editBtn",
    //   title: "عرض",
    //   ShowStatus: true,
    // },
  ];

  const RequestsManagerColumns = [];
  // send to read props popup
  const PopupOPjectData = {
    isPopupOpenStatus: popUpBodyStatus,

    isPopupOpenFunction: () => {},
    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const closePopUp = () => {
    setPopUpBodyStatus(false);
  };

  const popUpBody = {
    isPopupOpenStatus: popUpBodyStatus,
    isPopupOpenFunction: () => {
      setPopUpBodyStatus(false);
    },

    componentBody: <div></div>,

    title: "",
    maxWidth: "40%",
    maxHeight: "40%",
    idssss: "SecondarySectors",
  };

  const shouldDisableFields = "";
  const CloseTasksCcompleteInitialAssessmentFunction = async () => {
    const missingFields = [];

    if (!arrayDataCheckBoks || arrayDataCheckBoks.length === 0)
      missingFields.push("المهام المحددة");

    if (missingFields.length > 0) {
      Swal.fire({
        icon: "warning",
        title: "الرجاء اختيار مهمة واحدة على الاقل  ",
       
        confirmButtonText: "حسناً",
        customClass: {
          popup: "swal2-border-radius",
        },
      });
      return;
    }else{
        Swal.fire({
            icon: "success",
            title: "تمت العملية بنجاح",
            showConfirmButton: false,
            timer: 1500,
        })
    }
    dispatch(
      CloseTasksCcompleteInitialAssessment({
        subTaskIdList: arrayDataCheckBoks.map((ele) => ele?.subTaskId),
      })
     

    );
    dispatch(SetArrayDataCheckBoks())
        
  };
  const CloseTasksCcompleteInitialAssessmentResult = useSelector(
    (state) => state.SubTaskReducer.CloseTasksCcompleteInitialAssessmentResult
  );
  useEffect(() => {
    dispatch(setRefreshTable());
  }, [CloseTasksCcompleteInitialAssessmentResult]);
    useEffect(()=>{
        if(SubTaskReducerResult?.message === "Request Success"){
            Swal.fire({
                icon: "success",
                title: "تمت العملية بنجاح",
                showConfirmButton: false,
                timer: 1500,
            })
        }
    },[SubTaskReducerResult])
  return (
    <div>
      <TableAHSF
        culomEdite={culomEdite}
        uniqueValue={"subTaskId"}
        valueButtonAction={"subTaskId"}
        URL={`api/SubTasks/GetAllSubTasksByEvaluetorAssigninng`}
        UrlBody={{
          userGuid: state.UserInfo.userGuid,
        }}
        staticKeyEdite={staticKeyEdite}
        accessor={RequestAccessor}
        titelTable={""}
        selectRowNumber={true}
        checkBoksColumName="اختيار"
        sort={true}
        pagination={true}
        AppStatus={true}
        tableBtn={false}
        sortTable={true}
        uniqeKeyName={"subTaskId"}
        keyNameSort={"dateCreate"}
        dateKey="dateCreate"
        dateformat="DD/MM/YYYY h:mm a"
        arrayNameSort={["applicationNumber"]}
        search={true}
        openPopupState={false}
        checkBoks={true}
        uniqeKeyNameRedux={"SubtasksList_"}
        dataRedux={arrayDataCheckBoks}
        DropdownArrayFiltration={[]}
        DropdownFiltration={false}
        exportData={true}
        nameColumAction=""
        total={false}
        arrayButton={RequestsManagerBtns}
        ArrayNameDataColum={RequestsManagerColumns}
        columnKeyNameArray={[
          { keyName: "applicationNumber", nameColimn: " رقم الطلب" },
        ]}
        PopupOPjectData={PopupOPjectData}
        popUpTitle={"معلومات الطلب"}
        popUpBody={
          <PopupAHSF
            idssss="SecondarySectors"
            isPopupOpenStatus={popUpBody.isPopupOpenStatus}
            isPopupOpenFunction={popUpBody.isPopupOpenFunction}
            title={popUpBody.title}
            componentBody={popUpBody.componentBody}
            maxWidth={popUpBody.maxWidth}
            maxHeight={popUpBody.maxHeight}
          />
        }
      />
      <div className="containersButton">
        <div>
          <ButtonAHSF
            type={"submitter"}
            onClick={CloseTasksCcompleteInitialAssessmentFunction}
            disabled={false}
            // title={Object.keys(props).length == 0 ? "إضافة" : "تعديل"}
            text={jsonData?.CompletingEvaluationApplications?.nameAR}
            show={true}
          />
        </div>
      </div>
    </div>
  );
};

export default RequestsEvaluation;
